export default "__VITE_ASSET__CmLY8v3E__"